module.exports = __webpack_public_path__ + "img/antes_despues_146.981efcd2.png";